import script from "./DashboardDisclosure.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardDisclosure.vue?vue&type=script&setup=true&lang=js"

import "./DashboardDisclosure.vue?vue&type=style&index=0&id=aeb6de0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeb6de0e"]])

export default __exports__